<section *ngIf="!isLoading">
  <section class="px-[2rem] flex items-center justify-between">
    <h1 class="w-auto p-3 text-center text-[1.5rem]">Registar usuario</h1>
    <h1 class="text-[1.5rem]" (click)="close()">X</h1>
  </section>
  <form [formGroup]="form" class="p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
    <!-- Rol -->
    <mat-form-field class="w-full">
      <mat-label>Tipo de Usuario</mat-label>
      <mat-select formControlName="rol" (selectionChange)="onRoleChange($event.value)">
        <mat-option *ngFor="let role of listRol" [value]="role.name">
          {{ role.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Mostrar solo si el rol es Distribuidor -->
    <mat-form-field class="w-full" *ngIf="mostrarRolUsuario">
      <mat-label>Rol Usuario</mat-label>
      <mat-select formControlName="roles">
        <mat-option *ngFor="let element of listRoles" [value]="element.id">
          {{ element.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <!-- Administrador (Oculto si rol = EPS) -->
    <mat-form-field class="w-full" *ngIf="form.value.rol !== 'EPS'">
      <mat-label>Administrador</mat-label>
      <mat-select formControlName="administrador">
        <mat-option *ngFor="let admin of lisAdmin" [value]="admin.id">
          {{ admin.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Número de identificación -->
    <mat-form-field class="w-full">
      <mat-label>Número de Identificación</mat-label>
      <input matInput formControlName="numberId" type="text" appTrimInput />
    </mat-form-field>

    <!-- Apellido -->
    <mat-form-field class="w-full">
      <mat-label>Apellido</mat-label>
      <input matInput formControlName="lastName" type="text" />
    </mat-form-field>

    <!-- Nombre -->
    <mat-form-field class="w-full">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" type="text" />
    </mat-form-field>

    <!-- idEPS (Vacío si rol = Distribuidor) -->

    <mat-form-field class="w-full" *ngIf="form.value.rol !== 'Distribuidor' ">
      <mat-label>Selecciona la EPS</mat-label>
      <mat-select formControlName="idEPS">
        <mat-option *ngFor="let eps of listEps" [value]="eps.id">
          {{ eps.nameEPS }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- idPartner -->
    <mat-form-field class="w-full">
      <mat-label>ID Partner</mat-label>
      <input matInput formControlName="idPartner" type="text" />
    </mat-form-field>

    <!-- Teléfono -->
    <mat-form-field class="w-full">
      <mat-label>Teléfono</mat-label>
      <input matInput formControlName="phoneNumber" type="text" appTrimInput />
    </mat-form-field>

    <!-- Correo Electrónico -->
    <mat-form-field class="w-full">
      <mat-label>Correo Electrónico</mat-label>
      <input matInput formControlName="email" type="email" />
    </mat-form-field>

    <!-- <button (click)="openDialogModulos()">
      Modulos
    </button> -->

    <section class="w-full flex items-center justify-center">
      <button [disabled]="!form.valid" class="w-[40%] px-3 py-3" (click)="sendData()">Enviar</button>
    </section>

  </form>
</section>


<app-loading *ngIf="isLoading"></app-loading>